import Masks from "../services/Masks";

export default {
    props: [
        'lang',
        'initialProfile',
        'initialProfession',
        'initialSpecialty',
        'initialInterests',
        'professions',
        'specialties',
        'interests',
        'locale',
        'oldValues'
        // locale: {
        //     default: 'pt'
        // }
    ],

    data: () => { return {
        agreedToTerms: false,
        profile: null,
        profession: null,
        specialty: null,
        selectedInterests: [],
        masks: Masks,
        fields: {
            'phone': {
                'value': '',
                'mask': ''
            }
        }
    }},

    mounted: function() {

        this.fields['phone']['mask'] = this.masks.CellphoneWithDDD;

        if (this.oldValues !== undefined) {
            Object.keys(this.oldValues).forEach(function (index) {
                console.log(index);
               this.fields[index].value = this.oldValues[index];
            }.bind(this));
        }

        this.profile = this.initialProfile;

        if (this.initialProfession) {
            this.profession = this.professions[this.profile].find((p) => p.id === parseInt(this.initialProfession, 10));
        }

        if (this.initialSpecialty) {
            this.specialty = this.specialties[this.profession.id].find((s) => s.id === parseInt(this.initialSpecialty, 10));
        }

        if (this.initialInterests) {
            this.selectedInterests = this.initialInterests;
        }

        window.errorMessages = JSON.parse(this.lang);
        this.customErrorMessages();
    },

    methods: {
        showHidePassword: function(event) {
            let passwordField = document.getElementById('fld-register-password');
            let btnIcon = document.getElementById('fld-register-password-icon');
            let activeType = passwordField.getAttribute('type');

            if(activeType === 'password') {
                passwordField.setAttribute('type', 'text');
                btnIcon.setAttribute('class', 'fa fa-eye');
            }else{
                passwordField.setAttribute('type', 'password');
                btnIcon.setAttribute('class', 'fa fa-eye-slash');
            }
        },
        customErrorMessages: function (event) {

            //Password Confirmed Validation
            let passwordField = document.getElementById('fld-register-password');
            let passwordConfirmField = document.getElementById('fld-register-confirm_password');

            // passwordConfirmField.addEventListener("input", function (event) {
            //     if (passwordField.value !== passwordConfirmField.value) {
            //         console.log('field=', passwordField.value, 'confirm=', passwordConfirmField.value, 'fields:', passwordField, passwordConfirmField);
            //         passwordConfirmField.setCustomValidity(window.errorMessages.repeatPassword);
            //     } else {
            //         passwordConfirmField.setCustomValidity("");
            //     }
            // });

            //Email Confirmed Validation
            let emailField = document.getElementById('fld-register-email');
            let emailConfirmField = document.getElementById('fld-register-confirm_email');

            if (!emailConfirmField) {
                console.warn("Missing email confirm field");
                return;
            }

            emailConfirmField.addEventListener("input", function (event) {
                if (emailField.value !== emailConfirmField.value) {
                    emailConfirmField.setCustomValidity(window.errorMessages.repeatEmail);
                } else {
                    emailConfirmField.setCustomValidity("");
                }
            });
        },
        whenSubmit: function (e) {
            this.fields['phone']['mask'] = '';
            let phoneNumber = document.getElementById('fld-register-phone').value;
            this.fields['phone']['value'] = parseInt(phoneNumber.replace(/[^0-9]/g, ''), 10);
        }
    },
}
